<div class="db-tab-content" *ngIf="isActive">
  <ng-content></ng-content>
</div>
